import { Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { forkJoin, Observable, Subscription } from 'rxjs';

import { IFilterOptions } from 'src/app/models/filters';
import { BaseUrls, HeaderTitle } from 'src/app/models/generic';
import { ApiCommissionService } from 'src/app/services/api/api-commission.service';
import { ApiVerificationService } from 'src/app/services/api/api-verification.service';
import { DataService } from 'src/app/services/data.service';

import { IFilterContracts } from '../../../models/filters';
import { Mode, ModeType } from '../../../models/generic';
import { ApiLotsService } from '../../../services/api/api-lots.service';

@Component({
  selector: 'app-dash-filter',
  templateUrl: './dash-filter.component.html',
  styleUrls: ['./dash-filter.component.scss']
})
export class DashFilterComponent implements OnInit, OnDestroy {
  @Input() showFilters: boolean = false;
  @Input() filterOptions!: IFilterOptions;
  @Input() filterStatus: string[] = [];
  @Input() titleComponent!: HeaderTitle;
  @Input() mode!: ModeType;
  @Input() appearance: 'legacy' | 'accordion' = 'legacy';

  @HostBinding('class.accordion-host')
  get isAccordionHost(): boolean {
    return this.appearance === 'accordion';
  }

  Mode = Mode;

  openDropdown: 'status' | 'bank' | 'operationType' | null = null;

  filterForm!: FormGroup;
  titulo = 'Filtros';

  subs: Subscription[] = [];
  changeTabsSubscription!: Subscription;

  stages: string[] = [];
  status: string[] = [];
  statusBank: string[] = [];
  statusPeriod: string[] = [];
  isLegacy: FormControl<boolean | null> = new FormControl(false);
  isZeroRate: FormControl<boolean | null> = new FormControl(false);
  withoutBatch: FormControl<boolean | null> = new FormControl(false);


  opcoesStatus: { Status: string; Description: string }[] = [];
  buttonLabels = {
    clearFilter: 'Limpar Filtro',
    searchingFilter: 'Buscar'
  };
  sectionUrls: { [key: string]: string } = {
    [Mode.Contracts]: BaseUrls.Contract,
    [Mode.Invoicing]: BaseUrls.InvoicesLots,
    [Mode.Transfer]: BaseUrls.TransfersLots
  };
  statusRemovedFilter: string[] = [
    'aguardando nota fiscal',
    'aprovacao do lote',
    'erro',
    'solicitado',
    'liberado'
  ];

  constructor(
    private _fb: FormBuilder,
    private _verificationService: ApiVerificationService,
    private _dataService: DataService,
    private _activatedRoute: ActivatedRoute,
    private _commissionService: ApiCommissionService
  ) { }

  ngOnInit(): void {
    this.buildForm();

    if (!(this.mode === Mode.Transfer && this.titleComponent === 'Repasse de Comissão')) {
      this.resetFiltersApply();
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach((el) => el.unsubscribe());

    if (this.changeTabsSubscription)
      this.changeTabsSubscription.unsubscribe();
  }

  listeningEvents(): void {
    this.changeTabsSubscription = this._dataService.changeActiveTabs.subscribe({
      next: (tab) => {
        this.filterForm.reset();
      }
    });
  }



  checkCheckBoxvalue(event: Event) {
    if (this.isLegacyFormControl.value)
      this.isLegacyFormControl.setValue(false);
    else
      this.isLegacyFormControl.setValue(true);
  }

  checkCheckBoxvalueZeroRate(event: Event) {
    if (this.isZeroRateFormControl.value)
      this.isZeroRateFormControl.setValue(false);
    else
      this.isZeroRateFormControl.setValue(true);
  }

  checkCheckBoxvalueWithouBatch(event: Event) {
    this.withoutBatchFormControl.setValue(!this.withoutBatchFormControl.value);

  }

  getCheckedControl(control: AbstractControl): FormControl {
    return control.get('checked') as FormControl;
  }

  toggleDropdown(dropdown: 'status' | 'bank' | 'operationType'): void {
    this.openDropdown = this.openDropdown === dropdown ? null : dropdown;
  }

  closeDropdown(): void {
    this.openDropdown = null;
  }

  get statusTriggerLabel(): string {
    return this.comboTriggerLabel(this.statusInvoiceFormArray, 'Selecionar status');
  }

  get bankTriggerLabel(): string {
    return this.comboTriggerLabel(this.banksFormArray, 'Selecionar banco');
  }

  get operationTypeTriggerLabel(): string {
    return this.comboTriggerLabel(this.operationTypesFormArray, 'Selecionar operação');
  }

  private comboTriggerLabel(formArray: FormArray, placeholder: string): string {
    const selected = formArray.controls.filter((control) => control.value.checked);

    if (selected.length === 0)
      return placeholder;

    if (selected.length === 1)
      return selected[0].value.label;

    return `${selected.length} selecionados`;
  }

  private buildForm(): void {
    this.filterForm = this._fb.group({
      stages: new FormArray([]),
      statusInvoice: new FormArray([]),
      statusTransfer: new FormArray([]),
      statusOrder: new FormArray([]),
      statusBank: new FormArray([]),
      statusPeriod: new FormArray([]),
      banks: new FormArray([]),
      operationTypes: new FormArray([]),
      isLegacy: new FormControl(false),
      isZeroRate: new FormControl(false),
      withoutBatch: new FormControl(false),
    });

    this.listeningEvents();
    this.buildStatusFilters();
  }

  buildStatusFilters(): void {
    switch (this.mode) {
      case Mode.Commission:
        this.buildStatusBankAndPeriod().subscribe(() => {
          this.preencheSessaoBank();
        });
        break;

      case Mode.Contracts:
        this.buildStages().subscribe(() => {
          this.preencheSessaoStages();
        });
        this.buildInvoiceBatchStatus().subscribe(() => {
          this.preencheSessaoStatus();
        });
        break;

      case Mode.Invoicing:
        this.buildInvoiceBatchStatus().subscribe(() => {
          this.preencheSessaoStatus();
        });
        this.buildInvoiceBanksAndOperationTypes().subscribe(() => {
          this.preencheSessaoBanksAndOperationTypes();
        });
        break;

      case Mode.Transfer:
        this.buildTransferBatchStatus().subscribe(() => {
          this.preencheSessaoTransfer();
        });

        break;
    }
  }

  private buildStages(): Observable<any> {
    return new Observable((observer) => {
      const getAllStagesSub = this._verificationService.getAllStages().subscribe({
        next: (stages) => {

          stages.Data.forEach((el, i) => {
            this.stagesFormArray.push(
              this._fb.group({
                checked: [false, { nonNullable: true }],
                label: [el, { nonNullable: true }]
              })
            );
          });

          observer.next(null);
          observer.complete();
        },
        error: (error) => {
          observer.error(error);
        }
      });

      this.subs.push(getAllStagesSub);
    });
  }

  private buildInvoiceBatchStatus(): Observable<any> {
    return new Observable((observer) => {
      const getAllStatusSub = this._verificationService
        .getInvoiceFilterStatus(this.sectionUrls[this.mode])
        .subscribe({
          next: (status) => {
            this.opcoesStatus = status.Data;

            status.Data.forEach((el) => {
              if (
                !this.statusRemovedFilter.includes(el.Status.toLowerCase().trim())
              ) {
                this.statusInvoiceFormArray.push(
                  this._fb.group({
                    checked: [false, { nonNullable: true }],
                    label: [el.Description, { nonNullable: true }]
                  })
                );
              }
            });
            observer.next(null);
            observer.complete();
          },
          error: (error) => {
            observer.error(error);
          }
        });
      this.subs.push(getAllStatusSub);
    });
  }

  private buildInvoiceBanksAndOperationTypes(): Observable<any> {
    return new Observable((observer) => {
      const getBanksAndOperationTypesSub = forkJoin([
        this._verificationService.getInvoiceFilterBanks(),
        this._verificationService.getInvoiceFilterOperationTypes()
      ]).subscribe({
        next: ([banks, operationTypes]) => {
          banks.Data.forEach((bank) => {
            this.banksFormArray.push(
              this._fb.group({
                checked: [false, { nonNullable: true }],
                label: [bank, { nonNullable: true }]
              })
            );
          });

          operationTypes.Data.forEach((operationType) => {
            this.operationTypesFormArray.push(
              this._fb.group({
                checked: [false, { nonNullable: true }],
                label: [operationType, { nonNullable: true }]
              })
            );
          });

          observer.next(null);
          observer.complete();
        },
        error: (error) => {
          observer.error(error);
        }
      });
      this.subs.push(getBanksAndOperationTypesSub);
    });
  }

  private buildTransferBatchStatus(): Observable<any> {
    return new Observable((observer) => {
      const getAllStatusSub = this._verificationService
        .getTransferFilterStatus(this.sectionUrls[this.mode])
        .subscribe({
          next: (status) => {
            const batchStatuses = [...status.Data.BatchStatus];

            if (!batchStatuses.some((el) => el.Description?.toLowerCase() === 'em andamento')) {
              batchStatuses.push({
                Status: 'Em Andamento',
                Description: 'Em Andamento'
              });
            }

            batchStatuses.forEach((el) => {
              this.statusTransferFormArray.push(
                this._fb.group({
                  checked: [false, { nonNullable: true }],
                  label: [el.Description, { nonNullable: true }]
                })
              );
            });

            status.Data.OrderStatus.forEach((el) => {
              this.statusOrderFormArray.push(
                this._fb.group({
                  checked: [false, { nonNullable: true }],
                  label: [el.Description, { nonNullable: true }]
                })
              );
            });

            observer.next(null);
            observer.complete();
          },
          error: (error) => {
            observer.error(error);
          }
        });
      this.subs.push(getAllStatusSub);
    });
  }

  private buildStatusBankAndPeriod(): Observable<any> {
    return new Observable((observer) => {
      const getAllStagesSub = this._commissionService
        .getAllStatusBankAndPeriod()
        .subscribe({
          next: (status: any) => {
            status.Data.Banks.forEach((element: { [key: string]: string }) => {
              this.statusBankFormArray.push(
                this._fb.group({
                  checked: [false, { nonNullable: true }],
                  label: [element['Name'], { nonNullable: true }],
                  bankId: [element['BankId'], { nonNullable: true }]
                })
              );
            });

            status.Data.Periods.forEach((element: string) => {
              this.statusPeriodsFormArray.push(
                this._fb.group({
                  checked: [false, { nonNullable: true }],
                  label: [element, { nonNullable: true }]
                })
              );
            });
            observer.next(null);
            observer.complete();
          },
          error: (error) => {
            observer.error(error);
          }
        });
      this.subs.push(getAllStagesSub);
    });
  }

  get stagesFormArray() {
    return this.filterForm.get('stages') as FormArray;
  }

  get isLegacyFormControl() {
    return this.filterForm.get('isLegacy') as FormControl;
  }

  get isZeroRateFormControl() {
    return this.filterForm.get('isZeroRate') as FormControl;
  }

  get withoutBatchFormControl() {
    return this.filterForm.get('withoutBatch') as FormControl;
  }


  get statusInvoiceFormArray() {
    return this.filterForm.get('statusInvoice') as FormArray;
  }

  get statusTransferFormArray() {
    return this.filterForm.get('statusTransfer') as FormArray;
  }

  get statusOrderFormArray() {
    return this.filterForm.get('statusOrder') as FormArray;
  }

  get statusBankFormArray() {
    return this.filterForm.get('statusBank') as FormArray;
  }

  get statusPeriodsFormArray() {
    return this.filterForm.get('statusPeriod') as FormArray;
  }

  get banksFormArray() {
    return this.filterForm.get('banks') as FormArray;
  }

  get operationTypesFormArray() {
    return this.filterForm.get('operationTypes') as FormArray;
  }

  clearFilter(): void {
    this.stagesFormArray.controls.forEach((stages) => stages.reset());
    this.statusInvoiceFormArray.controls.forEach((status) => status.reset());
    this.statusTransferFormArray.controls.forEach((status) => status.reset());
    this.statusOrderFormArray.controls.forEach((status) => status.reset());
    this.statusBankFormArray.controls.forEach((statusBank) => statusBank.reset());
    this.statusPeriodsFormArray.controls.forEach((statusPeriods) => statusPeriods.reset());
    this.banksFormArray.controls.forEach((bank) => bank.reset());
    this.operationTypesFormArray.controls.forEach((operationType) => operationType.reset());
    this.isZeroRateFormControl.setValue(false);
    this.withoutBatchFormControl.setValue(false);
    this.applyFilters();
  }

  applyFilters(): void {

    const filtersToApply = {
      Stages: this.stagesFormArray
        .getRawValue()
        .filter((el) => el.checked)
        .map((el) => el.label.toLowerCase()),

      Status: this.statusInvoiceFormArray
        .getRawValue()
        .filter((el) => el.checked)
        .map(
          (el) =>
            this.opcoesStatus.find(
              (status) =>
                status.Description.toLowerCase() === el.label.toLowerCase()
            )!.Status.toLowerCase()
        ),

      StatusBank: this.statusBankFormArray
        .getRawValue()
        .filter((el) => el.checked)
        .map((el) => el.bankId.toLowerCase()),

      StatusPeriod: this.statusPeriodsFormArray
        .getRawValue()
        .filter((el) => el.checked)
        .map((el) => el.label.toLowerCase()),

      BatchStatuses: this.statusInvoiceFormArray
        .getRawValue()
        .filter((el) => el.checked)
        .map((el) => el.label.toLowerCase()),

      StatusOfOnlending: this.statusTransferFormArray
        .getRawValue()
        .filter((el) => el.checked)
        .map((el) => el.label.toLowerCase()),

      OrderStatus: this.statusOrderFormArray
        .getRawValue()
        .filter((el) => el.checked)
        .map((el) => el.label.toLowerCase()),

      Banks: this.banksFormArray
        .getRawValue()
        .filter((el) => el.checked)
        .map((el) => el.label.toLowerCase()),

      OperationTypes: this.operationTypesFormArray
        .getRawValue()
        .filter((el) => el.checked)
        .map((el) => el.label.toLowerCase()),

      IsLegacy: this.isLegacyFormControl.value,

      IsZeroRate: this.isZeroRateFormControl.value,
      WithoutBatch: this.withoutBatchFormControl.value
    };

    this._dataService.applyFilters(filtersToApply);

    if (this.mode == Mode.Invoicing)
      localStorage.setItem('bag_filter_i', JSON.stringify(filtersToApply));
    else
      localStorage.setItem('bag_filter', JSON.stringify(filtersToApply));

  }

  resetFiltersApply(): void {
    const filtersToApply: IFilterContracts = {
      Stages: [],
      Status: [],
      BatchStatuses: [],
      IsLegacy: false,
      IsZeroRate: false,
      WithoutBatch: false,
      StatusBank: [],
      StatusOfOnlending: [],
      OrderStatus: [],
      StatusPeriod: [],
      Banks: [],
      OperationTypes: []
    };

    this._dataService.applyFilters(filtersToApply);
  }

  preencheSessaoStages(): void {
    let bagSalva = JSON.parse(localStorage.getItem('bag_filter') ?? "{}");
    let bagStages = bagSalva.Stages;

    //this._fb.group({
    //  checked: [false, { nonNullable: true }],
    //  label: ['isZeroRate', { nonNullable: true }]
    //});

    //console.log(bagSalva.IsZeroRate);
    //this.isZeroRateFormControl.patchValue({ checked: true });
    //this.stagesFormArray.controls[1].patchValue({ checked: true });

    /*this.isZeroRateFormControl.patchValue({ checked: bagSalva.IsZeroRate });*/
    /*this.stagesFormArray.controls[1].patchValue({ checked: bagSalva.IsZeroRate });*/

    this.stagesFormArray.controls.forEach(
      stages => {
        if (bagStages != null) {
          const isChecked = bagStages.includes(stages.value.label.toLowerCase());
          stages.patchValue({ checked: isChecked });
        }
      }
    );
  }

  preencheSessaoStatus(): void {
    let bagSalva;

    if (this.mode == Mode.Invoicing)
      bagSalva = JSON.parse(localStorage.getItem('bag_filter_i') ?? "{}");
    else
      bagSalva = JSON.parse(localStorage.getItem('bag_filter') ?? "{}");

    let bagStatus = bagSalva.Status;

    this.statusInvoiceFormArray.controls.forEach(
      status => {
        if (bagStatus != null) {
          const isChecked = bagStatus.includes(status.value.label.toLowerCase());
          status.patchValue({ checked: isChecked });
        }
      }
    );
  }

  preencheSessaoBanksAndOperationTypes(): void {
    let bagSalva;

    if (this.mode == Mode.Invoicing)
      bagSalva = JSON.parse(localStorage.getItem('bag_filter_i') ?? "{}");
    else
      bagSalva = JSON.parse(localStorage.getItem('bag_filter') ?? "{}");

    let bagBanks = bagSalva.Banks;
    let bagOperationTypes = bagSalva.OperationTypes;

    this.banksFormArray.controls.forEach(
      bank => {
        if (bagBanks != null) {
          const isChecked = bagBanks.includes(bank.value.label.toLowerCase());
          bank.patchValue({ checked: isChecked });
        }
      }
    );

    this.operationTypesFormArray.controls.forEach(
      operationType => {
        if (bagOperationTypes != null) {
          const isChecked = bagOperationTypes.includes(operationType.value.label.toLowerCase());
          operationType.patchValue({ checked: isChecked });
        }
      }
    );
  }

  preencheSessaoTransfer(): void {
    let bagSalva = JSON.parse(localStorage.getItem('bag_filter') ?? "{}");
    let bagOrder = bagSalva.OrderStatus;
    let bagStatusOf = bagSalva.StatusOfOnlending;

    this.statusOrderFormArray.controls.forEach(
      order => {
        if (bagOrder != null) {
          const isChecked = bagOrder.includes(order.value.label.toLowerCase());
          order.patchValue({ checked: isChecked });
        }
      }
    );

    this.statusTransferFormArray.controls.forEach(
      transfer => {

        if (bagStatusOf != null) {
          const isChecked = bagStatusOf.includes(transfer.value.label.toLowerCase());
          transfer.patchValue({ checked: isChecked });
        }
      }
    );
  }

  preencheSessaoBank(): void {
    let bagSalva = JSON.parse(localStorage.getItem('bag_filter') ?? "{}");
    let bagBank = bagSalva.StatusBank;
    let bagPeriod = bagSalva.StatusPeriod;

    this.statusBankFormArray.controls.forEach(
      bank => {

        if (bagBank != null) {
          const isChecked = bagBank.includes(bank.value.bankId.toLowerCase());
          bank.patchValue({ checked: isChecked });
        }
      }
    );

    this.statusPeriodsFormArray.controls.forEach(
      Period => {

        if (bagPeriod != null) {
          const isChecked = bagPeriod.includes(Period.value.label.toLowerCase());
          Period.patchValue({ checked: isChecked });
        }
      }
    );
  }
}
